<!--
 * @Author: renxin
 * @Date: 2021-10-27 10:43:17
 * @LastEditors: renxin
 * @LastEditTime: 2024-05-17 15:50:43
 * @Description: 
-->
<template>
  <footer :class="bem()">
    <div class="footer-links">
      <a href="https://mshopact.vivo.com.cn/page/xservice" class="footer-link">特色服务</a>
      <a :href="config.path.shopKefu + '&source=orderpageh5'" class="footer-link">小v客服</a>
      <a :href="void 0" class="footer-link" @click="logout" v-if="isShowLogout">退出登录</a>
      <a :href="`${linkBase}/product/phone`" class="footer-link">选购手机</a>
    </div>
    <div class="rights">
      <span class="copyright">&copy;{{ new Date().getFullYear() }}shop.vivo.com.cn</span>
      <a href="http://wljg.gdgs.gov.cn/corpsrch.aspx?key=441900000425711" class="police"></a>
    </div>
  </footer>
</template>

<script>
import create from '../create'
import env from 'utils/clientEnv'
import API from 'api'
import config from 'config'
export default create({
  name: 'footer',
  data() {
    return {
      config: config
    }
  },
  computed: {
    isShowLogout() {
      return !(env.isWx || env.isAlipay)
    }
  },
  methods: {
    logout() {
      // 调用商城登出接口清除商城相关的cookie，然后重定向帐户登出清除登录态
      API.logout().then(
        () => {
          const redirectUrl = window.location.protocol + '//' + window.location.host + this.linkBase + '/index.html'
          window.location.replace(
            `https://passport.vivo.com.cn/v3/web/login/logout?client_id=3&redirect_uri=${redirectUrl}`
          )
        },
        e => {
          this.$toast(e.msg || '退出失败')
        }
      )
    }
  }
})
</script>

<style lang="scss" src="./index.scss" scoped></style>
